import { Storage } from './Storage';

const prefix = 'api/kanban';

function getHeaders() {
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store'
    };
    if (Storage.hasSecurityToken()) {
        headers.Authorization = 'Bearer ' + Storage.getSecurityToken();
    }
    return headers;
}

function handleError(resp) {
    if (resp.status === 401 || resp.status === 403) {
        throw new Error(AUTH_ERROR);
    }
    if (!resp.ok) {
        throw new Error(resp.statusText);
    }
    return resp;
}

export const AUTH_ERROR = "AuthError";

export class API {
    static toAPIUri(uri) {
        return prefix + uri;
    }

    

    static get(uri) {
        let headers = getHeaders();
        return fetch(API.toAPIUri(uri),
                {
                    method: 'GET',
                    headers
                })
                .then(handleError);
    }

    static post(uri, content) {
        let headers = getHeaders();
        return fetch(API.toAPIUri(uri),
            {
                method: 'POST',
                headers,
                body : JSON.stringify(content)
            })
            .then(handleError);
    }
}


// WEBPACK FOOTER //
// ./src/Logic/API.js